/* ==========================================================================
   dg-artist-hero.js — plays the film in the collection page opener

   One job, done carefully because of what the file weighs. Liquid exposes only the 1080p
   mp4 for these product videos (the .js API lists 480p and 720p as well; `media.sources`
   does not), so the section has no lighter rendition to choose and the clip is ~7MB.

   Three things follow from that:
     - it is never fetched on a metered or slow connection, or under Data Saver; the
       poster is a real <img> underneath, so the panel is a finished picture without it
     - it is not fetched until the window has loaded, so it never competes with the
       product grid the visitor actually came for
     - it is not fetched at all until the panel is on screen, and it pauses on the way out

   prefers-reduced-motion keeps the poster and downloads nothing.
   ========================================================================== */

/* Keep the opener's gutter equal to Boost's.

   Boost pads its full-width container by a fixed number of pixels rather than centring on
   a max-width, and it changes that number at its own breakpoints. dg-artist-hero.css ships
   the measured values as a fallback so there is no jump before this runs; this reads the
   real one and overwrites it, so the picture stays squared to the filter column even if
   Boost's breakpoints move under us. */
(function () {
  'use strict';

  var hero = document.querySelector('.dga');
  if (!hero) return;

  function align() {
    var box = document.querySelector('.boost-pfs-filter-wrapper .boost-pfs-container-default-fullwidth')
      || document.querySelector('.boost-pfs-filter-default-toolbar .boost-pfs-container-default-fullwidth');
    if (!box) return;
    var pad = parseFloat(window.getComputedStyle(box).paddingLeft);
    if (isNaN(pad)) return;
    hero.style.setProperty('--dga-gut', pad + 'px');
  }

  /* Boost renders its grid client-side, so the container may not exist yet on first run. */
  align();
  if (document.readyState === 'complete') { setTimeout(align, 0); }
  else { window.addEventListener('load', function () { align(); setTimeout(align, 400); }); }

  var pending;
  window.addEventListener('resize', function () {
    clearTimeout(pending);
    pending = setTimeout(align, 120);
  });
})();

(function () {
  'use strict';

  var panel = document.querySelector('[data-dga-film]');
  if (!panel) return;

  var video = panel.querySelector('video');
  if (!video) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var net = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (net) {
    if (net.saveData) return;
    var slow = /^(slow-)?2g$/.test(net.effectiveType || '');
    if (slow) return;
  }

  function start() {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          if (!video.getAttribute('src')) {
            var src = video.getAttribute('data-dga-film-src');
            if (src) video.setAttribute('src', src);
          }
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
          panel.classList.add('is-playing');
        } else {
          video.pause();
          panel.classList.remove('is-playing');
        }
      }
    }, { threshold: 0.15 });

    io.observe(panel);
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
